<script lang="ts">
  import { onDestroy, onMount, type Snippet } from "svelte"
  import CTA from "@kontextwerk/web-sdk/ui/actions/CTA.svelte"

  interface Props {
    instructions?: string[]
    subtitle?: string | null
    introText?: string | null
    outroText?: string | null
    note?: string | null
    hintText?: string | null

    onremoveOverlay?: () => void
    onshowOverlay?: () => void
    setActionButtonSnippet?: (snippet: Snippet | null) => void
  }

  let {
    instructions = [],
    subtitle = null,
    introText = null,
    outroText = null,
    note = null,
    hintText = null,
    onremoveOverlay = null,
    onshowOverlay = null,
    setActionButtonSnippet = null,
  }: Props = $props()

  const defaultInstructions: string[] = [
    "Im Quellsystem die gewünschten Daten öffnen.",
    "Export in einem gängigen Format (CSV, DOCX, PDF oder TXT) durchführen.",
    "Datei speichern und im Import-Assistenten hochladen.",
  ]

  const resolvedSteps = $derived(instructions.length ? instructions : defaultInstructions)
  const resolvedHintText = $derived(
    hintText ??
      "Die Anleitung ist exemplarisch. Menüpunkte können je nach Version abweichen. Entscheidend ist ein vollständiger Export.",
  )

  const closeOverlay = () => onremoveOverlay?.()

  onMount(() => {
    onshowOverlay?.()
    setActionButtonSnippet?.(footerActions)
  })

  onDestroy(() => {
    setActionButtonSnippet?.(null)
  })
</script>

{#if subtitle}
  <p class="lead">{subtitle}</p>
{/if}

{#if introText}
  <p class="hint">{introText}</p>
{/if}

<ul class="primary-list primary-list--light">
  {#each resolvedSteps as step, idx (idx)}
    <li>{step}</li>
  {/each}
</ul>

<p class="hint">{resolvedHintText}</p>

{#if note}
  <p class="note">{note}</p>
{/if}

{#if outroText}
  <p class="hint">{outroText}</p>
{/if}

{#snippet footerActions()}
  <CTA type="secondaryButton" content="Schließen" onClick={closeOverlay} />
{/snippet}
